'use strict';

// Mobile apps controller
angular.module('mobile-apps').controller('ShowImageController', [
  '$scope','$rootScope', '$modalInstance','$stateParams', 'entryKey', 'file', 'FilesMobileApps','$filter',
  function (
    $scope,
    $rootScope,
    $modalInstance,
    $stateParams,
    entryKey,
    file,
    FilesMobileApps,
    $filter
  ) {
    $scope.imageSrc = file.awsUrl;


	  $scope.mobileAppId = $stateParams.mobileAppId;
	  $scope.languageId = $stateParams.languageId;
	  $scope.entryId = $stateParams.entryId;

	  $scope.file = file;
	  $scope.entryKey = entryKey;

	  var getMetaDataString = function(metaData){
		  var result = '';
		  var metaInfo = {
			  screenTag: metaData.screenTag.name,
			  language: metaData.deviceLanguageLong,
			  resolution: metaData.width+'x'+metaData.height,
			  platform: metaData.platform,
			  deviceModel: metaData.deviceModel,
			  operatingSystem: metaData.operatingSystem,
			  bundleIdentifier: metaData.bundleIdentifier,
			  bundleVersion: metaData.bundleVersion,
			  sdkVersion: metaData.sdkVersion,
			  date: $filter('date')(metaData.updatedAt, 'EEEE, MMMM d, y, h:mm:ss a')
		  };
		  var keys = Object.keys(metaInfo);
		  for(var i = 0; i < keys.length; i++){
				result+=keys[i]+' -> "'+metaInfo[keys[i]]+'"\n';
		  }
		  return result;
	  };
	  var getTranslationStringList = function(translations){
		  var result = '';
		  for(var i = 0; i < translations.length; i++){
			  //console.log('key : '+translations[i].key);
			  result+=translations[i].key+' -> "'+translations[i].value+'"\n';
		  }
		  return result;

	  };
	  $scope.width = file.metaData?file.metaData.width:null;

	  $scope.screenHeight = file.metaData?file.metaData.screenHeight:null;
	  $scope.translations = file.metaData?file.metaData.stringPositions:null;
	  $scope.metaInfo = file.metaData?getMetaDataString(file.metaData):null;
	  $scope.translationList = file.metaData&&file.metaData.stringPositions?getTranslationStringList(file.metaData.stringPositions):null;
	  $scope.highlightConfig = {
		  'fade': true,
		  'alwaysOn': true,
		  'neverOn': false,
		  'fill': true,
		  'fillColor': '#ffffff',
		  'fillOpacity': 0.4,
		  'stroke': true,
		  'strokeColor': '#c21b00',
		  'strokeOpacity': 1,
		  'strokeWidth': 0.5,
		  'shadow': true,
		  'shadowColor': '#000000',
		  'shadowOpacity': 0.8,
		  'shadowRadius': 10
	  };

	  $scope.hasPosition = function(stringPos){
		  return stringPos.x!==-1 && stringPos.y!==-1 && stringPos.width!==-1 && stringPos.height!==-1;
	  };
	  $scope.stringCoords = function(stringPos){
		  //console.log('stringCoords called with :' );
		  //console.log(stringPos);
		  var tlx = stringPos.x-(stringPos.width/2);
		  var tly = stringPos.y-(stringPos.height/2);
		  var brx = stringPos.x+(stringPos.width/2);
		  var bry = stringPos.y+(stringPos.height/2);

		  var res =tlx+','+tly+','+brx+','+bry;
		  //console.log('result : '+res);
		  return res;
	  };

    var filesMobileApps = new FilesMobileApps(file);

    $scope.close = function () {
      $modalInstance.dismiss('close');
    };

    $scope.deleteFile = function(){
        filesMobileApps.$remove({
          mobileAppId: $stateParams.mobileAppId,
          fileId : file._id
        }, function () {
          $rootScope.$broadcast('FILE_DELETED_FOREVER',file);
          $modalInstance.dismiss('close');
        });

    };
  }
]);
